///
/// EarthBrowser
///
/// Wildfire legend body: the perimeter polygon fills and the location
/// marker. Polygons are a distinct visual vocabulary in the app, so this
/// removes the guesswork about what the filled shapes and colors mean.
///
/// Created by Matt Giger on 10/23/2026
/// Copyright (c) 2026 Geodata Labs
///

import { LegendFootnote, SymbolRow } from "./LegendPrimitives"

function PerimeterSwatch({ fill, border }: { fill: string; border: string }) {
	return <span className="w-6 h-4 rounded-sm border-2" style={{ backgroundColor: fill, borderColor: border }} />
}

export function WildfireLegendContent() {
	return (
		<>
			<SymbolRow swatch={<PerimeterSwatch fill="rgba(235, 36, 77, 0.28)" border="rgba(244, 63, 94, 0.9)" />}>
				Active fire perimeter
			</SymbolRow>
			<SymbolRow swatch={<PerimeterSwatch fill="rgba(140, 89, 97, 0.2)" border="rgba(166, 115, 122, 0.7)" />}>
				Contained fire
			</SymbolRow>
			<SymbolRow swatch={<span className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: "rgb(225, 29, 72)" }} />}>
				Fire location (click for details)
			</SymbolRow>
			<LegendFootnote>
				Marker size reflects acres burned. Zoom in to see the burned area outline. Data: NIFC, updated every few minutes.
			</LegendFootnote>
		</>
	)
}
